import {
  getPresignedUrl,
  uploadFileToAwsS3,
  deleteFileFromAwsS3,
  checkFileExists,
  downloadFile
} from 'services/storageService';
import { toast } from 'react-toastify';
import { processErrorResponse } from 'utils/errorHandler';

export const fetchPresignedUrl = (params) => async (dispatch) => {
  dispatch({ type: 'STORAGE_PRESIGNED_URL_REQUEST' });
  try {
    const result = await getPresignedUrl(params);
    dispatch({ type: 'STORAGE_PRESIGNED_URL_SUCCESS', payload: result });
    return result;
  } catch (error) {
    dispatch({ type: 'STORAGE_PRESIGNED_URL_FAILURE', error: error.message });
    processErrorResponse(error);
    throw error;
  }
};

export const uploadToS3 = (presignedUrl, contentType, file, onProgress) => async (dispatch) => {
  dispatch({ type: 'STORAGE_UPLOAD_REQUEST' });
  try {
    const result = await uploadFileToAwsS3(presignedUrl, contentType, file, onProgress);
    // Only store serializable data in Redux state
    const serializableResult = {
      status: result.status,
      statusText: result.statusText,
      headers: result.headers
    };
    dispatch({ type: 'STORAGE_UPLOAD_SUCCESS', payload: serializableResult });
    toast.success("File uploaded successfully!");
    return result;
  } catch (error) {
    dispatch({ type: 'STORAGE_UPLOAD_FAILURE', error: error.message });
    processErrorResponse(error);
    throw error;
  }
};

export const deleteFromS3 = (presignedUrl) => async (dispatch) => {
  dispatch({ type: 'STORAGE_DELETE_REQUEST' });
  try {
    const result = await deleteFileFromAwsS3(presignedUrl);
    dispatch({ type: 'STORAGE_DELETE_SUCCESS', payload: result });
    toast.success("File deleted successfully!");
    return result;
  } catch (error) {
    dispatch({ type: 'STORAGE_DELETE_FAILURE', error: error.message });
    processErrorResponse(error);
    throw error;
  }
};

export const verifyFileExists = (params) => async (dispatch) => {
  dispatch({ type: 'STORAGE_EXISTS_REQUEST' });
  try {
    const result = await checkFileExists(params);
    dispatch({ type: 'STORAGE_EXISTS_SUCCESS', payload: result });
    return result;
  } catch (error) {
    dispatch({ type: 'STORAGE_EXISTS_FAILURE', error: error.message });
    processErrorResponse(error);
    throw error;
  }
};

export const downloadFileFromS3 = (presignedUrl, fileName) => async (dispatch) => {
  dispatch({ type: 'STORAGE_DOWNLOAD_REQUEST' });
  try {
    const result = await downloadFile(presignedUrl, fileName);
    dispatch({ type: 'STORAGE_DOWNLOAD_SUCCESS', payload: result });
    toast.success("File downloaded successfully!");
    return result;
  } catch (error) {
    dispatch({ type: 'STORAGE_DOWNLOAD_FAILURE', error: error.message });
    processErrorResponse(error);
    throw error;
  }
};
